import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  const user = auth.getCurrentUser();
  if (!user) return router.createUrlTree(['/login']);

  const allowedRouteRoles: string[] = route.data['roles'] ?? [];
  const userRouteRole = auth.getRouteForRole(user.role);

  if (allowedRouteRoles.includes(userRouteRole)) return true;

  // Redirigir al dashboard del rol correcto si intenta acceder a una ruta que no le corresponde
  return router.createUrlTree([`/${userRouteRole}/dashboard`]);
};
